const DEFAULT_PROD_CMS_BASE = "https://cms.cosecglobal.com";
const DEFAULT_DEV_CMS_BASE = "http://localhost:1337";

export function getCmsBaseUrl() {
  const raw = process.env.REACT_APP_CMS_BASE_URL;
  if (raw) return raw.replace(/\/$/, "");
  return process.env.NODE_ENV === "production"
    ? DEFAULT_PROD_CMS_BASE
    : DEFAULT_DEV_CMS_BASE;
}

export function getCmsApiBaseUrl() {
  return `${getCmsBaseUrl()}/api`;
}
